<div class="recording-shelf-view">
  <div onsip-grid-placement-shelf>
    <div class="first-column">
      <section class="recording-name">
        <div class="mat-body-1 m-b-12">Name</div>
        <div>{{ recording.name }}</div>
      </section>
      <section class="recording-number">
        <div class="mat-body-1 m-b-12">Number</div>
        <div>{{ recording.number }}</div>
      </section>
      <section class="recording-location">
        <div class="mat-body-1 m-b-12">Location</div>
        <div>{{ recording.location.join(", ") }}</div>
      </section>
      <section class="recording-player">
        <div class="mat-body-1 m-b-12">Recording</div>
        <div class="recording-audio-container">
          <audio
            class="recording-audio-player"
            controls
            controlsList="nodownload"
            [src]="recording.recordingUrl"
          ></audio>
          <a
            id="admin-recording-greeting-download"
            [href]="recording.recordingUrl"
            download
            type="audio/wav"
          >
            <mat-icon aria-label="download_greetings">get_app</mat-icon>
          </a>
        </div>
      </section>
    </div>
  </div>

  <div class="page-view-controls">
    <button mat-flat-button class="toggle-button" color="primary" (click)="togglePanel()">
      {{ "ONSIP_I18N.EDIT_INFO" | translate }}
    </button>
  </div>
</div>
